import { Paintbrush, Layers } from "lucide-react";

export const serviceOptions = [
  "Механизированная штукатурка",
  "Полусухая стяжка",
  "Обе услуги",
  "Консультация",
] as const;

export type ServiceOption = (typeof serviceOptions)[number];

export const services = [
  {
    id: "plastering",
    number: "01",
    title: "Механизированная штукатурка стен",
    description:
      "Современная технология механизированного нанесения обеспечивает идеально ровные поверхности в кратчайшие сроки. Используем только высококачественные смеси и профессиональное оборудование от ведущих производителей.",
    icon: Paintbrush,
    features: [
      "Идеально ровные поверхности без дефектов",
      "Быстрое выполнение больших объёмов",
      "Экономия материалов на 20-30%",
      "Внутренние и наружные работы",
    ],
  },
  {
    id: "screed",
    number: "02",
    title: "Полусухая стяжка пола",
    description:
      "Инновационная технология полусухой механизированной стяжки позволяет создать идеально ровное основание для любого напольного покрытия всего за один день. Минимальная влажность и быстрый набор прочности.",
    icon: Layers,
    features: [
      "Укладка и выравнивание за один день",
      "Минимальная влажность — безопасно для помещения",
      "Совместимо с системой тёплого пола",
      "Толщина от 40 до 100 мм",
    ],
  },
] as const;

export type Service = (typeof services)[number];
